import { DataType } from 'components/table/types';
import { pendingRequestsTypes } from 'constants/requests.constants';

export type tableColumns = Partial<Record<pendingRequestsTypes, Record<string, DataType>>>;
const commonColumns: Record<string, DataType> = {
	createdAt: 'date',
	reference: 'string',
	createdBy: 'string',
	contactHebrewName: 'string',
};
export const tableColumns: tableColumns = {
	[pendingRequestsTypes.CONTACTS]: {
		createdAt: 'date',
		reference: 'string',
		requestedByContact: 'string',
		contactHebrewName: 'string',
		requestedName: 'string',
	},
	[pendingRequestsTypes.BALANCES]: {
		...commonColumns,
		amount: 'custom',
		currency: 'string',
		bankName: 'string',
		bankBranch: 'string',
		accountNumber: 'string',
	},
	[pendingRequestsTypes.BANK_ACCOUNTS]: {
		...commonColumns,
		accountOwnerName: 'string',
		bankName: 'string',
		bankBranch: 'string',
		accountNumber: 'string',
	},
	[pendingRequestsTypes.BENEFICIARIES]: {
		createdAt: 'date',
		updatedAt: 'date',
		reference: 'string',
		createdBy: 'string',
		contactHebrewName: 'string',
		nickname: 'string',
		companyName: 'string',
		typeHebrew: 'string',
		countryAtRiskDuringCreation: 'custom',
		bankCountryAtRisk: 'custom',
		countryIsTaxShelter: 'custom',
		bankCountryIsTaxShelter: 'custom',
		//wcHebrewStatus: 'string',
	},
	[pendingRequestsTypes.GENERAL_SUPPORT]: {
		...commonColumns,
		subject: 'string',
	},
	[pendingRequestsTypes.WITHDRAWAL_SUPPORT]: {
		...commonColumns,
		amount: 'integer',
		currencyName: 'custom',
		subjectWithdrawal: 'string',
	},
	[pendingRequestsTypes.PAYMENTS]: {
		...commonColumns,
		amount: 'custom',
		paymentType: 'custom',
		nickname: 'string',
		companyName: 'string',
	},
	[pendingRequestsTypes.BALANCES_BO_REQUESTS]: {
		createdAt: 'date',
		reference: 'string',
		contactHebrewName: 'string',
		balanceType: 'custom',
		amount: 'custom',
		currencyName: 'custom',
		firstSigner: 'custom',
		secondSigner: 'custom',
	},
	[pendingRequestsTypes.WITHDRAWAL_BO_APPROVED]: {
		createdAt: 'date',
		reference: 'string',
		createdBy: 'string',
		contactHebrewName: 'string',
		amount: 'custom',
		currency: 'string',
		status: 'string',
	},
	[pendingRequestsTypes.DIGITAL_BALANCES_REQUESTS]: {
		createdAt: 'date',
		companyName: 'string',
		feezbackUpdatedAt: 'date',
		amount: 'custom',
		reference: 'string',
		clientBankAccount: 'string',
		altshulerBankAccount: 'string',
		hyperAccountNumber: 'string',
		feezbackBankReferenceNumber: 'string',
		documentedOnHyperAction: 'custom',
	},
};
